<template>
  <div class="phonolenvs">
    <b-container fluid="xxl">
      <b-row>
        <b-col id="select-phonolenv">
          <b-form-group
            id="phonolenv"
            label="Phonol Env:"
            label-for="phonolenv"
          >
            <Select2 @select="select($event)" :settings="selectConfig" ref="select2" tabindex="0" />
          </b-form-group>

          <b-form-group
            id="ordering"
            label="Ordering:"
            label-for="ordering"
            v-if="showOrdering"
          >
            <b-form-input
              id="ordering"
              v-model="ordering"
              placeholder="Ordering"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <b-modal id="modal-new-phonol-env" title="New Phonol Env" ok-title="Save" @ok="saveNew" >
      <PhonolEnvNewEdit :phonolenv="{'form': this.query}" />
    </b-modal>
  </div>
</template>

<script>
import HelpStore from "@/store/helpstore.js";
import Select2 from 'v-select2-component';
import PhonolEnvNewEdit from "@/components/Scripta/PhonolEnvNewEdit.vue";
import config from '@/config.js';

export default {
  name: "PhonolEnvAutocomplete",
  props: ["exclude", "phonolEnv", "showOrdering", "headId", "orderingNum", "parentId"],
  data() {
    return {
      query: "",
      timer: null,
      phonolEnvObj: this.phonolEnv,
      parentIdElem: this.parentId ? this.parentId : "select-phonolenv",
      ordering: this.phonolEnv ? this.phonolEnv.ordering : (this.orderingNum ? this.orderingNum : 1),
      index: this.phonolEnv ? this.phonolEnv._index : null,
      showAddNew: this.allowNew == false ? false : true,
    };
  },
  components: {
    Select2,
    PhonolEnvNewEdit,
  },
  methods: {
    select(event){
      if (event.selected && event.id == -2){
        this.$bvModal.show("modal-new-phonol-env")
      }
      else {
        this.phonolEnvObj = event.selected ? event.phonolEnv : null
        this.$emit("select", this.phonolEnvObj)
        this.update()
      }
    },
    saveNew(){
      this.$store.dispatch('createPhonolenv', HelpStore.item).then((response) => {
        this.phonolEnvObj = response.data
        this.$refs.select2.select2.append(
          `<option selected value="${this.phonolEnvObj.id}">${this.phonolEnvObj.form}</option>`
        ).trigger('change')
        HelpStore.item = this.phonolEnvObj
      })
    },
    update(){
      if (this.phonolEnvObj){
        this.phonolEnvObj["ordering"] = this.ordering;
        this.phonolEnvObj["_index"] = this.index;
        HelpStore.item = this.phonolEnvObj;
      }
    },
  },
  updated() {
    this.update()
  },
  mounted() {
    if (this.phonolEnv){
      this.$refs.select2.select2.append(
        `<option selected value="${this.phonolEnv.id}">${this.phonolEnv.form}</option>`
      ).trigger('change')
    }
  },
  computed: {
    selectConfig(){
      return {
        placeholder: "Select a phonol env",
        // allowClear: this.allowClear == false ? false : true,
        width: '100%',
        dropdownParent: `#${this.parentIdElem}`,
        templateResult: (val) => {
          return val.form ? val.form : val.text
        },
        ajax: {
          delay: 250,
          url: config.apiUrl + '/phonolenvs/autocomplete',
          headers: config.apiHeaders,
          data: (params) => {
            this.query = params.term
            return {
              query: params.term,
              // headId: this.headId,
              exclude: JSON.stringify(this.exclude),
            }
          },
          processResults: (data) => {
            if (data.length == 0 && this.showAddNew && this.query){
              data.push({
                id: -2,
                form: `Create new "${this.query}"`
              })
            }
            return {
              results: data.map(phonolEnv => {
                let text = phonolEnv.form
                let orderNum = 0
                if (phonolEnv.id != -2 && !phonolEnv.heads.map(head => head.id).includes(this.headId)) {
                  text = `${text} (not connected to head)`
                  orderNum = 1
                }
                return {
                  id: phonolEnv.id,
                  text: text,
                  orderNum: orderNum,
                  form: phonolEnv.form,
                  phonolEnv: phonolEnv
                }
              }).sort((a, b) => a.orderNum - b.orderNum)
            }
          }
        }
      }
    }
  },
};
</script>
